import { apiInstance } from "../utils/_apiInstance";

export interface SavedSearchDetail {
  _id: string;
  nome: string;
  tipo: string;
  data: string;
  parametros?: {
    q?: string;
    limit?: number;
    page?: number;
    sort?: string;
    collectionType?: string;
    [key: string]: any;
  };
}

export const getSavedSearchById = async (id: string) => {
  const response = await apiInstance.get(`pesquisas-salvas/${id}`);
  return response.data;
};
